import Constant from '@/constant';
import soldocAPI from '@/api/soldoc';

export default {
    [Constant.REGISTER_BAROCARE_USER]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.registerBarocareUser(store.state.profile, store.state.agreements, store.state.card_info, payload.centerId)
                .then((response) => {
                    if(response.data.success == true)
                    {                        
                        resolve();
                    }

                })
                .catch((err) => {
                    // console.log(JSON.stringify(err.response));
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                })
        })
    },
    [Constant.FETCH_BAROCARE_NAME]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchBarocareName(payload.uuid)
                .then((response) => {
                    if(response.data.success == true)
                    {                        
                        resolve(response.data.data);
                    }

                })
                .catch((err) => {
                    // console.log(JSON.stringify(err.response));
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                })
        })
    },
    [Constant.REGISTER_BAROCARE_USER_SPECIFY]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.registerBarocareUserSpecify(store.state.profile_specify, store.state.agreements, payload.uuid, payload.groupId)
                .then((response) => {
                    if(response.data.success == true)
                    {                        
                        resolve();
                    }

                })
                .catch((err) => {
                    // console.log(JSON.stringify(err.response));
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                })
        })
    },
}


// WEBPACK FOOTER //
// ./src/store/actions.js